import { useState } from "react";
import LayoutNode from "vagaro-website-rendering/src/components/Definitions/LayoutNode";
import SliderFieldNoLabel from "./SliderFieldNoLabel";
import { AttributeFieldProps } from "./RenderAttributeInput";
import GearIcon from "../Icons/GearIcon";
import { AttributeTargetType, GetComponentOrStyleValueFromDefinition } from "../Data/WBData";
import FourDirectionFowField from "./FourDirectionRowField";
import { attributeTypes } from "vagaro-website-rendering/src/components/Definitions/AttributeTypes";
import { ScreenSize } from "vagaro-website-rendering/src/components/Definitions/ScreenSize";
import { wBComponentTypeNames } from "vagaro-website-rendering/src/components/Definitions/WBComponentTypeNames";

const dirs = ["Top","Right","Bottom","Left"];

export default function MeasurementField({label,definition,layoutObject,updateFunc,saveFunc,screenSize,siteData,isFourWay}:AttributeFieldProps&{isFourWay:boolean}){

let val = GetComponentOrStyleValueFromDefinition(definition,layoutObject,screenSize);
let inx = definition.options.length; // set to custom

const isFourwayValue = val.split("px").length>3;
const [dirKey,setDirKey] = useState(0);

for(let i = 0;i<definition.options.length;i++){

  if(definition.options[i].value == val){
    inx = i;
    break;
  }


}
const [currentSlection,setSelection] = useState(inx);
let isCustom = currentSlection>=definition.options.length;
const [showCustom,setShowCustom] = useState(isFourwayValue);

// if(isFourWay){

//   for(let i = 0;i<dirs.length;i++){

//     let val = getNodeStyleAttributeValue(layoutObject,screenSize,key+dirs[i]);
//     if(val!=""){
//       inx = definition.options.length;
//       break;
//     }
//   }

// }





let node = layoutObject as LayoutNode;
if(definition.attribute== attributeTypes.flexGrow && screenSize===ScreenSize.Mobile && node.parent&&node.parent.typename==wBComponentTypeNames.section){
  return null;
}


const updateAttribute =(newValue:string)=>{

  updateFunc(definition.attKey,newValue,definition.targetType);
  let index = (newValue.length<=0)?0:definition.options.length;



    for (let i = 0; i < definition.options.length; i++) {
      if (definition.options[i].value == newValue) {
        index = i;
        break;
      }
    }

    setSelection(index);

}


const updateAndClear = (attributeKey:string,attributeValue:string,targetType:AttributeTargetType)=>{
  if(isFourWay){
    setDirKey(dirKey+1);

   

  }
  updateFunc(attributeKey,attributeValue,targetType);
}

const UpdateFromFourway =  (attributeKey:string,attributeValue:string,targetType:AttributeTargetType)=>{
  

  updateFunc(attributeKey,attributeValue,targetType);

}

const FourWayButton = ()=>{
  if(isFourWay){
    return (<><button
    style={{maxWidth:"44px",marginLeft:"6px",padding:"12px",borderRadius:"4px"}}
    className={"invisible-button rounded-button "+(showCustom?"selected":"")}
    onClick={()=>{
      setShowCustom(!showCustom);
    }}
    >
<FourDirectionIcon/>
      
    </button></>);
  }
  return null;


}

return (
  <div className="wb-input-group">
    <label className={val==""?"not-updated":"updated"}>{label}</label>

    <div className="wb-input-row">
      {definition.options.map((option, index) => {
        let className = index == currentSlection ? "selected" : "";

        return (
          <button
            className={className}
            key={index}
            style={(option.label=="Auto")?{fontSize:"13px"}:{}}
            onClick={() => {
              updateAttribute(option.value);
            }}
          >
            {option.label}
          </button>
        );
      })}

      <button
      style={{maxWidth:"44px"}}
        className={
          currentSlection >= definition.options.length ? "selected" : ""
        }
        onClick={() => {
          setSelection(definition.options.length);
          saveFunc();
        }}
      >
        <GearIcon />
      </button>
    </div>

    <div key = {definition.attribute} className={isCustom?"range-drop-down-container active "+(isFourWay?"large":""):"range-drop-down-container "}>
      {isCustom && (
        <div className="flex-row" style={(isFourwayValue?{opacity:.7}:{})}>
        <SliderFieldNoLabel
        screenSize={screenSize}
        label ={label}
          definition={definition}
          layoutObject={layoutObject}
          updateFunc={updateAndClear}
          saveFunc={()=>{}}//saveFunc}
          siteData={siteData}
          trailing={
           <FourWayButton/>
          }
        />

        </div>
      )}
      {(isCustom && showCustom) && isFourWay &&  (
          // <Accordian label={"Custom"} startExpanded={isFourwayValue} wrapperClass="">
        <FourDirectionFowField
      
        screenSize={screenSize}
        label ={""}
        key = {dirKey} //reset every time the user changes the main value
          definition={definition}
          layoutObject={layoutObject}
          updateFunc={UpdateFromFourway}
          saveFunc={saveFunc}
          siteData={siteData}
          
        />
        // </Accordian>
      )}


    </div>
  </div>
);




}


function FourDirectionIcon(){

  let percSize = "36%";
  let radius = "4px";
  let border = "2px solid #444";

  return <div style={{position:"relative",width:"100%",paddingBottom:"100%"}}>
    <div style={{position:"absolute",borderRadius:`${radius} 0 0 0`,top:"0",left:"0",width:percSize,height:percSize,borderLeft:border,borderTop:border}}></div>
    <div style={{position:"absolute",borderRadius:`0 0 0 ${radius} `,bottom:"0",left:"0",width:percSize,height:percSize,borderLeft:border,borderBottom:border}}></div>
    <div style={{position:"absolute",borderRadius:`0 ${radius} 0 0`,top:"0",right:"0",width:percSize,height:percSize,borderRight:border,borderTop:border}}></div>
    <div style={{position:"absolute",borderRadius:` 0 0 ${radius} 0`,bottom:"0",right:"0",width:percSize,height:percSize,borderRight:border,borderBottom:border}}></div>
  </div>
}